import styled from "styled-components";

export const Container = styled.div`
  flex: 1;
  position: relative;
  display: flex;
  flex-direction: column;
`;
